import { RootState } from 'store/reducers'

export const selectBottomToast = (state: RootState) =>
  state.sharedData.bottomToast

export const selectCFDISyncInformation = (state: RootState) =>
  state.sharedData.syncInformation.cfdis

export const selectComplianceSyncInformation = (state: RootState) =>
  state.sharedData.syncInformation.compliance

export const selectExternalLinkURL = (state: RootState) =>
  state.sharedData.externalLinkURL
